/* eslint-disable camelcase, react/jsx-pascal-case */

import {Unstable_ActionHrefAdapterContext} from '@sail/ui';
import * as React from 'react';
import useActionHrefAdapter from 'src/internal/useActionHrefAdapter';

type Props = {
  children: React.ReactNode;
};

export default function NavigationUiProvider({
  children,
}: Props): React.ReactElement {
  return (
    <Unstable_ActionHrefAdapterContext.Provider value={useActionHrefAdapter}>
      {children}
    </Unstable_ActionHrefAdapterContext.Provider>
  );
}
